/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/nextjs-material-dashboard-pro
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
const skipped = (ctx, value) => (ctx.p0.skip || ctx.p1.skip ? value : undefined);
const down = (ctx, value) => (ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined);

const footer = (tooltipItems) => {
  return tooltipItems[0].dataset.tooltipItems[tooltipItems[0].dataIndex].map(
    (item) => `${item.title} : ${item.value ?? 'Not Updated'}`,
  );
};

const beforeTitle = (tooltipItems) => {
  console.log(tooltipItems);
  return [
    `Monitoring Date: ${tooltipItems[0].label}`,
    `Monitoring Type: ${tooltipItems[0].dataset.label}`,
  ];
};

function configs(labels, datasets) {
  return {
    data: {
      labels,
      datasets: datasets.map((dataset, index) => ({
        label: dataset.label,
        tension: 0.3,
        pointRadius: 5,
        pointBorderColor: 'transparent',
        pointBackgroundColor: dataset.backgroundColor,
        borderColor: dataset.backgroundColor,
        borderWidth: 4,
        backgroundColor: 'transparent',
        fill: true,
        data: dataset.data,
        maxBarThickness: 6,
        order: index,
        segment: {
          borderColor: (ctx) =>
            skipped(ctx, dataset.backgroundColor) || down(ctx, 'rgb(192,75,75)'),
          // borderDash: (ctx) => skipped(ctx, [6, 6]),
        },
        spanGaps: true,
        tooltipItems: dataset.quantitative || dataset.qualitative,
      })),
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: '#f8f9fa',
          },
        },
        tooltip: {
          label: false,
          callbacks: {
            footer: footer,
            title: beforeTitle,
            label: (item) => '', // it's disable the title
          },
        },
      },
      interaction: {
        intersect: false,
        mode: 'index',
      },
      scales: {
        y: {
          min: 0,
          display: true,
          title: {
            display: true,
            text: 'Height (m.)',
            color: '#f8f9fa',
            font: {
              size: 14,
              weight: 300,
              family: 'Roboto',
              style: 'normal',
              lineHeight: 2,
            },
          },
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: 'rgba(255, 255, 255, .2)',
          },
          ticks: {
            min: 0,
            // stepSize: 10,
            display: true,
            color: '#f8f9fa',
            padding: 10,
            margin: 10,
            font: {
              size: 14,
              weight: 300,
              family: 'Roboto',
              style: 'normal',
              lineHeight: 2,
            },
          },
        },
        x: {
          display: true,
          title: {
            display: true,
            text: 'Monitoring Date',
            color: '#f8f9fa',
            font: {
              size: 14,
              weight: 300,
              family: 'Roboto',
              style: 'normal',
              lineHeight: 2,
            },
          },
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            color: '#f8f9fa',
            padding: 5,
            font: {
              width: '5px',
              size: 10,
              weight: 300,
              family: 'Roboto',
              style: 'normal',
              lineHeight: 1,
            },
          },
        },
      },
    },
  };
}

export default configs;
